import { PRINT_CSS, type PrintProduct } from "@/shared/lib/printLayout";
import { PrintPoster } from "./PrintPoster";

const A4_WIDTH = 793;
const A4_HEIGHT = 1122;

interface PosterPreviewProps {
  url: string;
  qrSrc: string;
  logoSrc: string;
  product: PrintProduct;
  /** Ширина превью; макет ужимается под неё пропорционально. */
  width: number;
}

/**
 * Превью печатного макета — тот же компонент, что уходит в печать, ужатый до
 * заданной ширины. Расхождению между превью и результатом взяться неоткуда.
 */
export function PosterPreview({ url, qrSrc, logoSrc, product, width }: PosterPreviewProps) {
  const scale = width / A4_WIDTH;

  return (
    <div
      className="flex-none overflow-hidden rounded-lg border border-input-border bg-white shadow-[0_1px_2px_rgba(0,0,0,0.04)]"
      style={{ width, height: Math.round(A4_HEIGHT * scale) }}
    >
      <style>{PRINT_CSS}</style>
      <div style={{ transform: `scale(${scale})`, transformOrigin: "0 0" }}>
        <PrintPoster url={url} qrSrc={qrSrc} logoSrc={logoSrc} product={product} />
      </div>
    </div>
  );
}
